import createHistory from "history/createBrowserHistory"

import { createBrowserHistory } from "history"

const history = createHistory()
export default history

export const changeUrl = createBrowserHistory({
  // esto se usa en reportes, para que pueda cambiar el link y al actualizar mantenga la URL actual
})
